class VideosHandler {
  constructor() {
    this.videosMap = {};
  }
  addVideoToMap(payload) {
    this.videosMap[payload.id] = payload.video;
  }

  removeVideoFromMap(payload) {
    if (typeof this.videosMap[payload.id] !== 'undefined') {
      delete this.videosMap[payload.id];
    }
  }
  pauseAllVideosExcept(videoId) {
    for (let [id, video] of Object.entries(this.videosMap)) {
      if (id.toString() !== videoId.toString()) {
        video.pause();
      }
    }
  }
}

const videosHandlerInstance = new VideosHandler();

export {
  videosHandlerInstance
}
